import React from "react";
import { Route, Routes } from "react-router-dom";
import { RACT } from "./containers";
import { ProtectedRoute } from "../../shared";
import { EditBirthdayCouponsV2 } from "../BirthdayCouponsV2";

export const RACTRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<RACT />} />
      <Route element={<ProtectedRoute allowedRoute={["coupon-modify"]} />}>
        <Route path="/edit" element={<EditBirthdayCouponsV2 type="ract" />} />
      </Route>
    </Routes>
  );
};
